import { all, put, takeLatest } from 'redux-saga/effects';

import {
  GET_COMPLAINTS_LIST,
  GET_COMPLAINTS_LIST_FAILURE,
  GET_COMPLAINTS_LIST_SUCCESS,
} from '../../modules/constants';
import { defaultApi } from '../../utils/axiosApi';

function* handleGetComplaintsList({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const url = `/albait/complaints/?${queryParams}`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_COMPLAINTS_LIST_SUCCESS,
      payload: response,
    });
  } catch (err) {
    yield put({
      type: GET_COMPLAINTS_LIST_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([takeLatest(GET_COMPLAINTS_LIST, handleGetComplaintsList)]);
}
